export default "__VITE_ASSET__pDQ$Hg25__"